import React from "react";
import * as FaIcons from "react-icons/fa";
import * as RiIcons from "react-icons/ri";
import pedidos from "../img/iconos-roll-over/pedidos.png";
import pedidosVerde from "../img/iconos-verdes/pedidos-verde.png";
import impuestos from "../img/iconos-roll-over/impuestos.png";
import producto from "../img/iconos-roll-over/producto.png";
import listaDePrecios from "../img/iconos-roll-over/lista_de_precios.png";
import configuracion from "../img/iconos-roll-over/configuracion.png";

export const SidebarDataOrders = [
    {
        title: "orders_title",
        path: "/Orders/Analytics",
        icon: <img src={pedidos} width="32px" alt="" />,
        activeIcon: <img src={pedidosVerde} width="32px" alt="" />,
        iconClosed: <RiIcons.RiArrowDownSFill />,
        iconOpened: <RiIcons.RiArrowUpSFill />,
        id: "ordersMenu",
        subNav: [
            {
                title: "orders_title",
                path: "/Orders/",
                icon: <FaIcons.FaCircle className="iconSubmenu" />,
                id: "ordersPlatform"
            },
            {
                title: "orders_dashboard_analytics",
                path: "/Orders/Analytics",
                icon: <FaIcons.FaCircle className="iconSubmenu" />,
                id: "ordersDashboardAnalytics"
            }
        ]
    },
    {
        title: "orders_taxes",
        path: "/Orders/",
        icon: <img src={impuestos} width="32px" alt="" />,
        iconClosed: <RiIcons.RiArrowDownSFill />,
        iconOpened: <RiIcons.RiArrowUpSFill />,
        id: "ordersTaxes"
    },
    {
        title: "orders_products",
        path: "/Orders/Analytics",
        icon: <img src={producto} width="32px" alt="" />,
        iconClosed: <FaIcons.FaChevronDown className="arrowIcon" />,
        iconOpened: <FaIcons.FaChevronDown className="arrowIcon" />,
        id: "ordersProductsMenu",
        subNav: [
            {
                title: "orders_products",
                path: "/Orders/",
                icon: <FaIcons.FaCircle className="iconSubmenu" />,
                id: "ordersProducts"
            },
            {
                title: "orders_import",
                path: "/Orders/",
                icon: <FaIcons.FaCircle className="iconSubmenu" />,
                id: "ordersImport"
            }
        ]
    },
    {
        title: "orders_pricelist",
        path: "/Orders/",
        icon: <img src={listaDePrecios} width="32px" alt="" />,
        iconClosed: <RiIcons.RiArrowDownSFill />,
        iconOpened: <RiIcons.RiArrowUpSFill />,
        id: "ordersPriceList"
    },
    {
        title: "orders_configuration",
        path: "/Orders/",
        icon: <img src={configuracion} width="32px" alt="" />,
        iconClosed: <RiIcons.RiArrowDownSFill />,
        iconOpened: <RiIcons.RiArrowUpSFill />,
        id: "ordersConfiguration"
    }
];
